import { SimpleGrid } from "@chakra-ui/layout";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";
import colors from "core/resources/theme/colors";
import { AiOutlineCalendar, AiOutlineCheck } from "react-icons/ai";
import { MdAttachMoney } from "react-icons/md";
import { BiBarChart } from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";
import { ConsumoDto, ConsumoDashboardDto } from "core/features/consumo/typings";
import { useState } from "react";
import ModalEditarConsumo from "./../ModalEditarConsumo";
import { formatMoney } from "infra/helpers/number";
import { FaEdit } from "react-icons/fa";
import { mapUnidadeMedidaExtenso } from "core/features/consumo/typings";
import { Flex, Text } from "@chakra-ui/react";

interface DetalhesConsumoProps {
  consumo?: ConsumoDto;
  dashboard?: ConsumoDashboardDto;
  isLoading?: boolean;
  isLoadingDashboard?: boolean;
  refetch?: () => any;
}

function DetalhesConsumo({
  consumo,
  dashboard,
  isLoading,
  isLoadingDashboard,
  refetch,
}: DetalhesConsumoProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <SimpleGrid mt="8px" columns={[3, 3, 3, 3, 6]} gap="16px">
        <Card1Horizontal
          bg={colors.green100}
          title={`${consumo?.diaMedicao || "--"}`}
          icon={<AiOutlineCalendar fontSize="24px" color={colors.green} />}
          color={colors.green}
          description="Dia da medição"
          loading={isLoading}
          onClick={() => setIsOpenModal(true)}
          fontSize={20}
          topIcon={<FaEdit color={colors.black600} />}
        />

        <Card1Horizontal
          bg={colors.blue100}
          title={`${
            consumo?.valorUnidade ? formatMoney(consumo.valorUnidade) : "--"
          }`}
          icon={<MdAttachMoney fontSize="24px" color={colors.blue} />}
          description={`${
            consumo?.unidadeMedida
              ? `Por ${mapUnidadeMedidaExtenso[consumo.unidadeMedida]}`
              : "Valor por medida"
          }`}
          color={colors.blue}
          loading={isLoading}
          onClick={() => setIsOpenModal(true)}
          fontSize={20}
          topIcon={
            <Flex alignItems="center" gap={2}>
              {consumo?.faixas?.length ? (
                <Text
                  fontSize={9.5}
                  fontWeight="light"
                  noOfLines={2}
                  mt={0.5}
                  title="Com faixas de consumo"
                >
                  Com faixas de consumo
                </Text>
              ) : null}
              <FaEdit color={colors.black600} />
            </Flex>
          }
        />

        <Card1Horizontal
          bg={colors.gray50}
          title={`${dashboard?.somaTotal ?? 0}${
            consumo?.unidadeMedida ? ` ${consumo.unidadeMedida}` : ""
          }`}
          icon={<BiBarChart fontSize="24px" color={colors.gray} />}
          color={colors.gray}
          description="Soma total"
          loading={isLoading || isLoadingDashboard}
          fontSize={20}
        />

        <Card1Horizontal
          bg={colors.green100}
          title={`${dashboard?.unidadesComMedida ?? 0}`}
          icon={<AiOutlineCheck fontSize="24px" color={colors.green} />}
          description="Unidades medidas"
          loading={isLoading || isLoadingDashboard}
          color={colors.green}
          fontSize={20}
        />

        <Card1Horizontal
          bg={colors.red100}
          title={`${
            (dashboard?.totalUnidades ?? 0) -
            (dashboard?.unidadesComMedida ?? 0)
          }`}
          icon={<BsThreeDots fontSize="24px" color={colors.red} />}
          description="Unidades a medir"
          loading={isLoading || isLoadingDashboard}
          color={colors.red}
          fontSize={20}
        />

        <Card1Horizontal
          bg={colors.gray50}
          title={`${dashboard?.totalConsumo ?? 0}${
            consumo?.unidadeMedida ? ` ${consumo.unidadeMedida}` : ""
          }`}
          icon={<BiBarChart fontSize="24px" color={colors.gray} />}
          color={colors.gray}
          description="Consumo total"
          loading={isLoading || isLoadingDashboard}
          fontSize={20}
          topIcon={
            <Flex alignItems="center" gap={2} mt={1} pr={2}>
              {dashboard?.valorCobradoTotal ? (
                <Text
                  fontSize={10.5}
                  fontWeight="light"
                  noOfLines={2}
                  title={`Valor total: ${formatMoney(
                    dashboard.valorCobradoTotal
                  )}`}
                >
                  Valor total: {formatMoney(dashboard.valorCobradoTotal)}
                </Text>
              ) : null}
            </Flex>
          }
        />
      </SimpleGrid>

      {consumo && isOpenModal ? (
        <ModalEditarConsumo
          onClose={() => setIsOpenModal(false)}
          consumo={consumo}
          open={isOpenModal}
          refetch={refetch}
        />
      ) : null}
    </>
  );
}

export default DetalhesConsumo;
